<template>
    <div class="swAbout" v-if="Object.keys(this.form).length">
        <div class="head-box">
            <navBar :isNav2="true"></navBar>
        </div>
        <div class="content">
            <!-- banner -->
            <div class="banner-box" v-img="{ form: form.bannerObj, key: 'img' }"
                :style="'background-image: url(' + form.bannerObj.img + ')'">
                <div class="c-box">
                    <div class="container1">
                        <div class="text-content wow fadeInUp">
                            <p class="name pingFang-Bold font46" v-edit="{ form: form.bannerObj, key: 'title' }">{{
                                form.bannerObj.title }}</p>
                            <p class="name pingFang-Bold font46" v-edit="{ form: form.bannerObj, key: 'content' }">{{
                                form.bannerObj.content }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 关于我们内容1 -->
            <div class="swAbout1" v-img="{ form: form.firstObj, key: 'img' }"
                :style="'background-image: url(' + form.firstObj.img + ')'">
                <div class="c-box">
                    <div class="container1 wow fadeInUp">
                        <h2 class="font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</h2>
                        <div class="c-text font18" v-edit="{ form: form.firstObj, key: 'content' }"
                            v-html="form.firstObj.content"></div>
                        <div class="c-infoul">
                            <div class="c-infoli" v-for="(item, key) in form.firstObj.list" :key="key">
                                <div class="c-cont1 font60" v-edit="{ form: item, key: 'title' }">
                                    {{ item.title }}
                                    <span class="font30" v-edit="{ form: item, key: 'type' }">{{ item.type }}</span>
                                </div>
                                <div class="c-cont2 font16" v-edit="{ form: item, key: 'content' }">
                                    {{ item.content }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 关于我们内容2 -->
            <div class="swAbout2">
                <div class="container1">
                    <h2 class="font40 wow fadeInUp" v-edit="{ form: form.secoundObj, key: 'title' }">{{
                        form.secoundObj.title }}</h2>
                    <ul>
                        <li class="wow fadeInUp" v-for="(item, key) in form.secoundObj.list" :key="key">
                            <div class="imgbox">
                                <img :src="item.imgBoxObj.img" v-img="{ form: item.imgBoxObj, key: 'img' }" alt="" />
                            </div>
                            <div class="c-text">
                                <div class="c-div1 font20" v-edit="{ form: item, key: 'title' }">
                                    <p>{{ item.title }}</p>
                                </div>
                                <div class="c-div2 font16">
                                    <p v-for="(items, keys) in item.list" :key="keys"
                                        v-edit="{ form: items, key: 'title' }">
                                        {{ items.title }}
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- 关于我们内容3 -->
            <div class="swAbout3" v-img="{ form: form.thiredObj, key: 'img' }"
                :style="'background-image: url(' + form.thiredObj.img + ')'">
                <div class="container1" @click.stop>
                    <h2 class="font40 wow fadeInUp" v-edit="{ form: form.thiredObj, key: 'title' }">{{
                        form.thiredObj.title }}</h2>
                </div>
                <div class="swAboutSwp1  wow fadeInUp" @click.stop>
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, key) in form.thiredObj.list" :key="key">
                                <itemAdd :list="form.thiredObj.list" :itemIndex="key"></itemAdd>
                                <div class="c-div1">
                                    <div class="scrollY">
                                        <div class="c-text font16" v-for="(items, keys) in item.list" :key="keys"
                                            v-edit="{ form: item.list, key: keys }">
                                            <itemAdd :list="item.list" :itemIndex="keys"></itemAdd>
                                            {{ items }}
                                        </div>
                                        <div class="c-text on font16" v-if="item.smallContent"
                                            v-edit="{ form: item, key: 'smallContent' }">{{ item.smallContent }}</div>
                                    </div>
                                </div>
                                <div class="c-div2 font28" v-edit="{ form: item, key: 'time' }">
                                    {{ item.time }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 关于我们内容4 -->
            <div class="swAbout4">
                <div class="container1">
                    <h2 class="font40 wow fadeInUp" v-edit="{ form: form.fourthObj, key: 'title' }">{{
                        form.fourthObj.title }}</h2>
                    <div class="c-box">
                        <div class="imgbox wow fadeInUp">
                            <img :src="form.fourthObj.img" v-img="{ form: form.fourthObj, key: 'img' }" alt="" />
                        </div>
                        <div class="c-left wow fadeInUp">
                            <img class="c-img" src="../assets/images/about-12.png" alt="" />
                            <ul>
                                <li v-for="(item, key) in form.fourthObj.leftList" :key="key">
                                    <div class="c-div1 font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}
                                    </div>
                                    <div class="c-div2 font16" v-edit="{ form: item, key: 'content' }">{{ item.content
                                        }}</div>
                                </li>
                            </ul>
                        </div>

                        <div class="c-left c-right wow fadeInUp">
                            <img class="c-img" src="../assets/images/about-12.png" alt="" />
                            <ul>
                                <li v-for="(item, key) in form.fourthObj.rightList" :key="key">
                                    <div class="c-div1 font20" v-edit="{ form: item, key: 'title' }">{{ item.title }}
                                    </div>
                                    <div class="c-div2 font16" v-edit="{ form: item, key: 'content' }">{{ item.content
                                        }}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 关于我们内容5 -->
            <div class="swAbout5">
                <div class="container1 wow fadeInUp">
                    <h2 class="font40" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</h2>
                    <div class="c-title-text font24" v-edit="{ form: form.fifthObj, key: 'content' }">
                        {{ form.fifthObj.content }}
                    </div>
                    <div class="btnBox" :class="{ on: swpActive == 1 }">
                        <div class="font18 c-btn" v-for="(item, key) in form.fifthObj.list" :key="key"
                            :class="{ on: swpActive == key }" @click="swpChange(key)"
                            v-edit="{ form: item, key: 'title' }">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
                <div class="container1 wow fadeInUp">
                    <div class="swAboutSwp2-box wow fadeInUp">
                        <div class="swAboutSwp2" :class="['swAboutSwp2_' + index, { on: swpActive == index }]"
                            v-for="(items, index) in form.fifthObj.list" :key="index">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(item, keys) in items.list" :key="keys">
                                        <itemAdd :list="items.list" :itemIndex="keys"></itemAdd>
                                        <div class="a">
                                            <div class="imgbox">
                                                <img :src="item.imgSrc"
                                                    v-img="{ form: items.list[keys], key: 'imgSrc' }" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-button-prev"></div>
                                <div class="swiper-button-next"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="156" :id="131"></submit-form>
    </div>
</template>

<script>
import Swiper from 'swiper'; //  ES6 导入swiper js文件
import 'swiper/dist/css/swiper.min.css'; // ES6 导入swiper css文件
import navBar from '../components/navBar.vue';
import { initWow } from '@/utils/wow';
import { pageQuery } from '../api/index';
import submitForm from '../components/submit-form.vue';
import itemAdd from '../components/item-add.vue';
export default {
    name: '',
    data() {
        return {
            activeName: 0,
            itemLength: 0,
            swpActive: 0,
            form: {}
        };
    },
    mounted() {
        pageQuery({ componentId: '156', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
                // 大事记轮播
                var swAboutSwp1 = new Swiper('.swAboutSwp1 .swiper-container', {
                    slidesPerView: 3.6,
                    spaceBetween: 30,
                    navigation: {},
                    breakpoints: {
                        1290: {
                            slidesPerView: 2.6
                        },
                        991: {
                            slidesPerView: 2.5,
                            spaceBetween: 20
                        },
                        767: {
                            slidesPerView: 1,
                            spaceBetween: 20
                        }
                    }
                    // autoplay: {
                    // 	delay: 4000,
                    // },
                });

                // HiImgPop($(".honor-swp .swiper-slide .a"));

                // 荣誉资质轮播
                var swpCxlt_arr = [];
                $('.swAboutSwp2 .swiper-container').each(function (index, item) {
                    var i = index;
                    swpCxlt_arr[i] = new Swiper($(this), {
                        observer: true,
                        observeParents: true,
                        slidesPerView: 3,
                        spaceBetween: 130,
                        loop: true,
                        centeredSlides: true,
                        navigation: {
                            nextEl: '.swAboutSwp2_' + i + ' .swiper-button-next',
                            prevEl: '.swAboutSwp2_' + i + ' .swiper-button-prev'
                        },
                        // autoplay: {
                        // 	delay: 5000,
                        // },
                        breakpoints: {
                            1580: {
                                spaceBetween: 90
                            },
                            1260: {
                                spaceBetween: 70
                            },
                            991: {
                                spaceBetween: 60
                            },
                            767: {
                                slidesPerView: 1,
                                spaceBetween: 15
                            }
                        }
                    });
                });
            });
        });
    },
    computed: {},
    methods: {
        // 荣誉资质按钮切换
        swpChange(x) {
            this.swpActive = x;
            for (var i = 0; i < this.swAboutSwp2.length; i++) {
                this.swAboutSwp2[i].active = false;
            }
            this.swAboutSwp2[x].active = true;
        }
    },
    components: { navBar, submitForm, itemAdd },
    beforeDestroy() { },
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;

    .navbar .nav-link {
        color: #333333;
    }

    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }

    .navbar .nav-link .arrow {
        background-image: url(../assets/images/arrow-down2.svg);
    }

    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }

    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }

    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}

.head-box {
    position: relative;
    z-index: 10;
}

// 滚动条
.gdt(@c) {
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 1px;
    }

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px #ddd;
        background-color: #ddd;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 7px;
        -webkit-box-shadow: inset 0 0 6px @c;
        background-color: @c;
    }
}

.fd {
    overflow: hidden;

    img {
        transition: all 0.4s;
    }

    &:hover {
        img {
            transform: scale(1.05);
        }
    }
}

.swAbout {

    // banner
    .banner-box {
        width: 100%;
        height: 0;
        padding-bottom: 37.5%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        position: relative;

        @media (max-width: 768px) {
            padding-bottom: 100%;
            background-size: cover;
        }

        .c-box {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .text-content {
                text-align: center;
                color: #fff;
                margin-bottom: 55px;

                @media @max-sm {
                    margin-bottom: 45px;
                }
            }
        }
    }

    // 关于我们内容1
    .swAbout1 {
        width: 100%;
        height: 0;
        padding-bottom: 42.96%;
        position: relative;
        background-size: 100% 100%;

        @media @max-sm {
            padding-bottom: 60%;
        }

        @media @max-xs {
            height: auto;
            padding-bottom: unset;
            background-size: cover;
            padding: 60px 0 45px;
        }

        .c-box {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;

            @media @max-xs {
                position: unset;
            }

            h2 {
                font-weight: bold;
                width: 46.07%;

                @media @max-xs {
                    width: 100%;
                }
            }

            .c-text {
                width: 46.07%;
                color: #65697f;
                line-height: 1.66;
                margin-top: 20px;
                .gdt(#ea5404);

                @media (max-width: 990px) {
                    font-size: 14px;
                }

                @media @max-xs {
                    width: 100%;
                    padding-right: 15px;
                }
            }

            .c-infoul {
                display: flex;
                margin-top: 70px;

                @media (max-width: 1260px) {
                    margin-top: 50px;
                }

                @media @max-xs {
                    flex-wrap: wrap;
                }

                @media (max-width: 768px) {
                    margin-top: 25px;
                }

                .c-infoli {
                    margin-right: 65px;

                    @media @max-xs {
                        width: 50%;
                        margin-right: 0;
                        margin-bottom: 20px;
                    }

                    .c-cont1 {
                        color: #ea5404;
                        font-weight: bold;

                        @media (max-width: 1580px) {
                            font-size: 42px;
                        }

                        @media (max-width: 1260px) {
                            font-size: 38px;
                        }

                        @media (max-width: 990px) {
                            font-size: 32px;
                        }

                        @media (max-width: 768px) {
                            font-size: 26px;
                            margin-bottom: 5px;
                        }

                        .c-syb {
                            font-weight: 400;
                        }
                    }

                    .c-cont2 {
                        color: #65697f;

                        @media (max-width: 768px) {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }

    // 关于我们内容2
    .swAbout2 {
        background: #f1f3f5;
        padding: 120px 0 105px;

        @media (max-width: 1580px) {
            padding: 100px 0 85px;
        }

        @media (max-width: 1260px) {
            padding: 80px 0 75px;
        }

        @media @max-xs {
            padding: 60px 0 30px;
        }

        h2 {
            width: 100%;
            text-align: center;
            font-weight: bold;
            margin-bottom: 45px;

            @media @max-xs {
                margin-bottom: 40px;
            }
        }

        ul {
            display: flex;
            // flex-wrap: wrap;
            justify-content: center;
            margin-right: -2.85%;

            li {
                width: 31.42%;
                margin-right: 2.85%;
                background: #fff;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;

                position: relative;
                transition: all 0.3s;

                @media @max-xs {
                    width: 100%;
                    margin-right: 0;
                    margin-bottom: 25px;
                }

                &:hover {
                    transform: translateY(-10px);
                }

                &::before {
                    content: '';
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    box-shadow: 3px 0px 59px 0px rgba(35, 36, 37, 0.06);
                    bottom: 0;
                    left: 0;
                    height: 70%;
                }

                &:nth-of-type(3n + 3) {
                    margin-right: 0;
                }

                .imgbox {
                    width: 100%;
                    height: 0;
                    padding-bottom: 43.18%;
                    position: relative;

                    .c-name {
                        position: absolute;
                        bottom: 20px;
                        right: 0;
                        color: #fff;
                        width: 50%;
                        line-height: 1.2;

                        .c-div1,
                        .c-div2 {
                            color: rgba(255, 255, 255, 0.07);
                            font-weight: bold;

                            @media (max-width: 1260px) {
                                font-size: 26px;
                            }

                            @media @max-xs {
                                line-height: 1.4;
                            }
                        }

                        .c-div2 {
                            margin-left: 30px;
                        }

                        .c-div3 {
                            line-height: 1.6;
                            margin-left: 30px;

                            @media (max-width: 1260px) {
                                font-size: 24px;
                            }

                            @media @max-xs {
                                font-size: 20px;
                            }
                        }
                    }

                    img {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .c-text {
                    padding: 35px 30px 60px;

                    @media (max-width: 1260px) {
                        padding: 25px 20px 40px;
                    }

                    @media @max-xs {
                        padding-bottom: 30px;
                    }

                    .c-div1 {
                        color: #333;
                        position: relative;

                        p {
                            background: #fff;
                            padding-right: 20px;
                            position: relative;
                            z-index: 2;
                            display: inline-block;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            right: 0;
                            width: 100%;
                            height: 1px;
                            background: #e6e6e6;
                            z-index: 1;
                        }
                    }

                    .c-div2 {
                        color: #65697f;
                        line-height: 2;
                        margin-top: 15px;

                        @media (max-width: 1260px) {
                            margin-top: 5px;
                        }

                        @media @max-xs {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }

    // 关于我们内容3
    .swAbout3 {
        padding: 115px 0;

        @media (max-width: 1580px) {
            padding: 100px 0;
        }

        @media (max-width: 1260px) {
            padding: 90px 0;
        }

        @media (max-width: 768px) {
            padding: 60px 0 50px;
        }

        h2 {
            margin-bottom: 105px;
            text-align: center;
            font-weight: bold;

            @media (max-width: 1580px) {
                margin-bottom: 70px;
            }

            @media (max-width: 1260px) {
                margin-bottom: 60px;
            }

            @media @max-xs {
                margin-bottom: 35px;
            }
        }

        .swAboutSwp1 {
            overflow: hidden;
            padding-left: 210px;

            @media (max-width: 1260px) {
                padding-left: 140px;
            }

            @media (max-width: 1024px) {
                padding-left: 65px;
            }

            @media (max-width: 990px) {
                padding-left: 55px;
            }

            @media (max-width: 768px) {
                padding-left: 5%;
                padding-right: 5%;
            }

            .swiper-container {
                margin-top: -20px;
                padding-top: 20px;
                overflow: unset;
            }

            .swiper-wrapper {
                .swiper-slide {
                    .c-div1 {
                        background: #fff;
                        padding: 50px 35px 40px 0;
                        border-radius: 8px;
                        box-shadow: 9px 0px 20px 0px rgba(0, 0, 0, 0.05);
                        position: relative;

                        @media (max-width: 1260px) {
                            padding: 40px 25px 30px 0;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            border: 8px solid rgba(0, 0, 0, 0);
                            border-top-color: #fff;
                            top: 100%;
                            left: 40px;
                        }

                        .scrollY {
                            height: 135px;
                            overflow-y: auto;
                            padding-left: 35px;

                            &::-webkit-scrollbar {
                                width: 1px;
                            }

                            &::-webkit-scrollbar-track {
                                -webkit-box-shadow: inset 0 0 6px #ddd;
                                background-color: #ddd;
                                border-radius: 3px;
                            }

                            &::-webkit-scrollbar-thumb {
                                border-radius: 7px;
                                -webkit-box-shadow: inset 0 0 6px #ea5404;
                                background-color: #ea5404;
                            }
                        }

                        .c-text {
                            position: relative;
                            padding-left: 20px;
                            margin-bottom: 10px;

                            @media @max-xs {
                                font-size: 14px;
                                line-height: 1.6;
                            }

                            &::before {
                                content: '';
                                position: absolute;
                                width: 5px;
                                height: 5px;
                                top: 12px;
                                left: 0;
                                background: #494a4d;
                                border-radius: 1000px;

                                @media (max-width: 1580px) {
                                    top: 10px;
                                }
                            }

                            &.on {
                                color: #416aff;

                                &::before {
                                    background: #416aff;
                                }

                                &::after {
                                    content: '';
                                    position: absolute;
                                    width: 15px;
                                    height: 15px;
                                    background: url('../assets/images/about-7.png');
                                    top: 7px;
                                    left: -5px;

                                    @media (max-width: 1580px) {
                                        top: 5px;
                                    }
                                }
                            }
                        }
                    }

                    .c-div2 {
                        position: relative;
                        margin-top: 30px;
                        padding-top: 25px;
                        padding-left: 44px;
                        color: #333;

                        &::after {
                            content: '';
                            position: absolute;
                            background: url('../assets/images/about-10.png');
                            width: calc(100% + 210px);
                            left: -210px;
                            height: 7px;
                            top: -2px;
                            z-index: -1;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            width: 8px;
                            height: 8px;
                            border-radius: 1000px;
                            background: #ea5404;
                            top: 0;
                        }
                    }
                }
            }
        }
    }

    // 关于我们内容4
    .swAbout4 {
        background: #f2f4f6;
        padding: 120px 0;

        @media (max-width: 1580px) {
            padding: 110px 0;
        }

        @media (max-width: 1260px) {
            padding: 100px 0;
        }

        @media (max-width: 990px) {
            padding: 90px 0 220px;
        }

        @media (max-width: 767px) {
            padding: 60px 0 25px;
        }

        .container1 {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        h2 {
            color: #121826;
            font-weight: bold;
            text-align: center;
            margin-bottom: 60px;

            @media (max-width: 1260px) {
                margin-bottom: 50px;
            }

            @media (max-width: 768px) {
                margin-bottom: 35px;
            }
        }

        .c-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            @media @max-xs {
                flex-direction: column;
            }

            .imgbox {
                width: 100%;
                width: 38.57%;
                height: 0;
                padding-bottom: 48.21%;
                position: relative;
                z-index: 2;
                .fd;
                border-radius: 8px;

                @media (max-width: 1580px) {
                    width: 42%;
                }

                @media (max-width: 1260px) {
                    padding-bottom: 62.21%;
                }

                @media (max-width: 1024px) {
                    padding-bottom: 72%;
                }

                @media @max-xs {
                    width: 100%;
                }

                img {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;
                }
            }

            .c-left {
                position: absolute;
                top: 0;
                left: 0;
                background: #fff;
                padding: 60px 60px;
                min-height: 450px;
                border-radius: 8px;
                top: 95px;
                z-index: 3;
                width: 37.64%;

                @media (max-width: 1580px) {
                    min-height: 370px;
                    padding: 40px;
                    width: 34%;
                }

                @media (max-width: 1260px) {
                    min-height: 300px;
                }

                @media @max-xs {
                    position: relative;
                    top: unset;
                    left: unset;
                    width: 100%;
                    min-height: unset;
                    padding: 30px 20px 10px;
                    margin-top: 35px;
                    margin-bottom: 35px;
                }

                li {
                    margin-bottom: 20px;

                    .c-div1 {
                        color: #333;
                        font-weight: bold;
                    }

                    .c-div2 {
                        color: #65697f;

                        @media (max-width: 1580px) {
                            font-size: 16px;
                        }

                        @media (max-width: 1260px) {
                            font-size: 15px;
                        }

                        @media @max-xs {
                            font-size: 14px;
                            line-height: 1.6;
                        }
                    }
                }

                img {
                    position: absolute;
                    top: -20px;
                    left: 45px;
                    width: 55px;

                    @media (max-width: 1580px) {
                        width: 45px;
                    }

                    @media @max-xs {
                        width: 35px;
                        left: 20px;
                        top: -15px;
                    }
                }
            }

            .c-right {
                left: unset;
                right: 0;
                min-height: unset;
                top: 300px;
                padding-left: 110px;
                padding-right: 80px;
                z-index: 1;
                width: 33.21%;

                @media (max-width: 1260px) {
                    width: 30%;
                    padding-left: 45px;
                    padding-right: 45px;
                }

                @media (max-width: 1024px) {
                    z-index: 4;
                    width: 36%;
                    padding-left: 40px;
                    padding-right: 40px;
                }

                @media @max-xs {
                    position: relative;
                    top: unset;
                    left: unset;
                    width: 100%;
                    min-height: unset;
                    margin-top: 0;
                    padding-left: 20px;
                    padding-right: 20px;
                }

                img {
                    left: 95px;

                    @media (max-width: 1260px) {
                        left: 45px;
                    }

                    @media @max-xs {
                        left: 20px;
                    }
                }
            }
        }
    }

    // 关于我们内容5
    .swAbout5 {
        padding: 120px 0 140px;

        @media (max-width: 1580px) {
            padding: 100px 0;
        }

        @media (max-width: 990px) {
            padding: 90px 0;
        }

        @media @max-xs {
            padding: 60px 0;
        }

        .container1 {
            // display: flex;
            // flex-direction: column;
            // align-items: center;
            overflow: visible;

            &:nth-child(1) {
                text-align: center;
            }
        }

        h2 {
            text-align: center;
            font-weight: bold;
            color: #121826;
        }

        .c-title-text {
            text-align: center;
            color: #5a6779;

            @media (max-width: 1580px) {
                font-size: 16px;
            }

            @media @max-xs {
                font-size: 14px;
            }
        }

        .btnBox {
            display: inline-flex;
            background: #f2f4f6;
            border-radius: 1000px;
            position: relative;
            margin: 35px auto 50px;

            @media (max-width: 1580px) {
                margin: 25px auto 40px;
            }

            @media @max-xs {
                margin-bottom: 35px;
            }

            &::before {
                content: '';
                position: absolute;
                background: #eb5405;
                width: 50%;
                height: 100%;
                border-radius: 1000px;
                top: 0;
                left: 0;
                transition: all 0.3s;
            }

            &.on {
                &::before {
                    left: 50%;
                }
            }

            .c-btn {
                padding: 13px 35px;
                cursor: pointer;
                transition: all 0.3s;
                color: rgba(51, 51, 51, 0.6);
                border-radius: 1000px;
                position: relative;
                z-index: 1;

                @media (max-width: 1580px) {
                    padding: 10px 35px;
                }

                @media @max-xs {
                    font-size: 14px;
                }

                &.on {
                    color: #fff;
                }
            }
        }

        .swAboutSwp2-box {
            position: relative;

            .swAboutSwp2 {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                overflow: unset;
                height: 0;
                padding-bottom: 23%;
                // display: none;
                opacity: 0;
                transition: all 0.3s;

                @media @max-xs {
                    height: auto;
                    padding-bottom: 65px;
                }

                &.on {
                    position: relative;
                    z-index: 5;
                    opacity: 1;
                }

                // &.swAboutSwp2_0{
                // 	display: block;
                // }
                .swiper-container {
                    position: unset;
                }

                .swiper-wrapper {
                    align-items: center;
                }

                .swiper-slide {
                    opacity: 0.4;
                    transition: all 0.3s;

                    .a {
                        padding: 20px;
                        border: 4px solid #333;
                        border-radius: 8px;

                        @media (max-width: 1580px) {
                            padding: 10px;
                        }

                        @media @max-xs {
                            border: 3px solid #333;
                        }

                        .imgbox {
                            width: 100%;
                            height: 0;
                            padding-bottom: 69%;
                            position: relative;
                            transition: all 0.3s;

                            img {
                                position: absolute;
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }

                .swiper-slide-active {
                    opacity: 1;

                    .a {
                        .imgbox {
                            padding-bottom: 80%;

                            @media @max-xs {
                                padding-bottom: 69%;
                            }
                        }
                    }
                }

                .swiper-button-next,
                .swiper-button-prev {
                    background-size: 10px 12px;
                    background-position: center;
                    background-repeat: no-repeat;
                    border-radius: 1000px;
                    border: 1px solid #d1d1d1;
                    width: 55px;
                    height: 55px;
                    transition: all 0.3s;

                    @media (max-width: 1580px) {
                        width: 45px;
                        height: 45px;
                    }

                    @media (max-width: 990px) {
                        width: 40px;
                        height: 40px;
                    }

                    @media @max-xs {
                        top: unset;
                        transform: unset;
                        bottom: 0;
                    }

                    &:hover {
                        border-color: #eb5405;
                        background-color: #eb5405;
                    }
                }

                .swiper-button-prev {
                    left: 30.5%;
                    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23d1d1d1'%2F%3E%3C%2Fsvg%3E");

                    &:hover {
                        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
                    }

                    @media (max-width: 990px) {
                        left: 30%;
                    }

                    @media @max-xs {
                        left: 35%;
                    }
                }

                .swiper-button-next {
                    right: 30.5%;

                    &:hover {
                        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
                    }

                    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23d1d1d1'%2F%3E%3C%2Fsvg%3E");

                    @media (max-width: 990px) {
                        right: 30%;
                    }

                    @media @max-xs {
                        right: 35%;
                    }
                }
            }
        }
    }
}
</style>
